import type { FC } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { BoxedSliderField } from "web_myplann/Inspiration/Components/BoxedSliderField";
import { InspirationSheet } from "web_myplann/Inspiration/Components/InspirationSheet";
import {
	OWN_HOME_EXPENSES_FALLBACK,
	OWN_HOME_EXPENSES_FIELD,
	OWN_HOME_INCOME_FALLBACK,
	OWN_HOME_INCOME_FIELD,
} from "web_myplann/Inspiration/OwnHome/constants";
import type { OwnHomeAffordabilityValues } from "web_myplann/Inspiration/OwnHome/Types/OwnHomeAffordabilityValues";
import { useResetStateOnOpen } from "web_myplann/Shared/Hooks/useResetStateOnOpen";

const R = Resources.Inspiration.OwnHome.AffordabilitySheet;

type Props = {
	open: boolean;
	initialIncome?: number;
	initialExpenses?: number;
	showExpenses: boolean;
	onClose: () => void;
	onSubmit: (data: OwnHomeAffordabilityValues) => void;
};

export const AffordabilityEditSheet: FC<Props> = ({
	open,
	initialIncome,
	initialExpenses,
	showExpenses,
	onClose,
	onSubmit,
}) => {
	const { t } = useResource();
	const [income, setIncome] = useResetStateOnOpen(
		open,
		initialIncome ?? OWN_HOME_INCOME_FALLBACK,
	);
	const [expenses, setExpenses] = useResetStateOnOpen(
		open,
		initialExpenses ?? OWN_HOME_EXPENSES_FALLBACK,
	);

	return (
		<InspirationSheet
			open={open}
			onClose={onClose}
			title={t(R.title)}
			description={t(R.description)}
			primaryLabel={t(R.submit)}
			onPrimary={() =>
				onSubmit({ income, expenses: showExpenses ? expenses : undefined })
			}
		>
			<BoxedSliderField
				label={t(R.incomeLabel)}
				value={income}
				onChange={setIncome}
				{...OWN_HOME_INCOME_FIELD}
			/>

			{showExpenses && (
				<BoxedSliderField
					label={t(R.expensesLabel)}
					value={expenses}
					onChange={setExpenses}
					{...OWN_HOME_EXPENSES_FIELD}
				/>
			)}
		</InspirationSheet>
	);
};
